<template>
  <div class="time">
    <div class="number">{{ pad(hours) }}</div>
    <div class="dot">:</div>
    <div class="number">{{ pad(minutes) }}</div>
    <div class="dot">:</div>
    <div class="number">{{ pad(seconds) }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import giveawayTimeMixin from "../../mixins/giveawayTimeMixin"
export default defineComponent({
  name: "TimeComponent",
  mixins: [giveawayTimeMixin],
})
</script>

<style lang="scss" scoped>
.time {
  display: flex;
  align-items: center;
  gap: 8px;

  .number {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 48px;
    height: 36px;
    background: #212429;
    border-radius: 12px;

    font-family: "Druk Text Wide Cyr";
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
  }

  .dot {
    width: 6px;
    height: 20px;

    font-family: "Druk Text Wide Cyr";
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
